<template>
  <div class="">
    <div class="">
      <Card :StyleProp="'my-1'" back>
        <template v-slot:header>
          <h5>فیلتر گزارش درخواست ها</h5>
          <div class="row">
            <div class="col-md-12" dir="rtl">
              <small>انتخاب کارمندان</small>
              <treeselect
                name="CustomerContract"
                :multiple="multiple"
                :clearable="clearable"
                :searchable="searchable"
                :open-on-click="openOnClick"
                :open-on-focus="openOnFocus"
                :clear-on-select="clearOnSelect"
                :close-on-select="closeOnSelect"
                :always-open="alwaysOpen"
                :append-to-body="appendToBody"
                :options="options"
                v-model="value"
                :normalizer="normalizer"
                @select="ItemSelected"
                @deselect="ItemDeselect"
                value-consists-of="LEAF_PRIORITY"
              >
              </treeselect>
            </div>
            <div class="col-lg-2 col-12 mt-3">
              <small>انتخاب فرم</small>
              <select class="form-control" v-model="filter.FormAutomationId">
                <option :value="item.id" v-for="(item, key) in FormList" :key="key">{{ item.formName }}</option>
                <option :value="-1">همــــــــــه</option>
              </select>
            </div>
            <div class="col-lg-2 col-12 mt-3">
              <small>تاریخ شروع گزارش</small>
              <date-picker color="dimgray" input-class="required form-control" clearable :editable="true" placeholder=" از تاریخ " v-model="filter.TarixAz"></date-picker>
            </div>
            <div class="col-lg-1 col-12 mt-3">
              <div class="mt-3">
                <i class="fad fa-arrow-alt-up mx-2 mt-2 Pointer hover-success" style="font-size: 20px" title="ماه بعدی" @click="GotoNextMonth"></i>
                <i class="fad fa-arrow-alt-down mx-2 mt-2 Pointer hover-danger" style="font-size: 20px" title="ماه قبلی" @click="GotoPreventMonth"></i>
              </div>
            </div>
            <div class="col-lg-2 col-12 mt-3">
              <small>تاریخ پایان گزارش</small>
              <date-picker color="dimgray" input-class="required form-control" clearable :editable="true" placeholder=" تا تاریخ " v-model="filter.TarixTa"></date-picker>
            </div>
            <div class="col-lg-3 col-12 mt-3">
              <small>انتخاب وضعیت درخواست</small>
              <!-- <div class="text-center form-control">
                <div class="text-center">
                  <div class="custom-control custom-switch">
                    <small id="LbltblComboGrpId50" class="ml-2"> بایگانی شده </small>
                    <input type="checkbox" class="custom-control-input required InputText" id="Done" v-model="filter.IsArchive" />
                    <label class="custom-control-label" for="Done"> </label>
                    <small class="mr-5"> باز </small>
                  </div>
                </div>
              </div> -->
              <select class="form-control" v-model="filter.IsArchive">
                <option :value="-1">همه حالت ها</option>
                <option :value="0">باز</option>
                <option :value="1">بایگانی شده</option>
              </select>
            </div>
            <div class="col-md-2 col-12 mt-3">
              <button type="button" class="btn btn-success w-100 mt-4" @click="SearchReport"><i class="fad fa-search ml-1"></i> اعمال فیلتر</button>
            </div>
          </div>
        </template>
      </Card>
      <div class="row">
        <div class="col-lg-3 col-12 BUser">
          <div v-for="(val, key) in ResultReport" :key="key">
            <Card :StyleProp="'my-1 animate__animated animate__bounceIn'" class="m-1">
              <template v-slot:header>
                <small class="text-center Pointer" v-b-toggle="'collapse-' + key" @click="Sort(val, key)"><i class="fad fa-user text-info ml-4"></i> {{ val[0].nameUserReq }}</small>
              </template>
            </Card>

            <b-collapse :id="'collapse-' + key" :accordion="'collapse-'" class="pl-2 pr-2">
              <div class="FormStyle mt-1" v-for="(v, k) in ResultReportForm" :key="k">
                <div class="mr-3 mt-1 Pointer" @click="ShowDetail(v)">{{ v[0].formName }}</div>
              </div>
              <!-- <div class="FormStyle mt-1">
                <div class="mr-3 mt-1 Pointer" @click="ShowDetail(ResultReportForm)">همه فرم ها</div>
              </div> -->
            </b-collapse>
          </div>
        </div>
        <div class="col-lg-9 col-12 animate__animated animate__bounceIn" v-if="IsShowDetails">
          <Card :StyleProp="'my-1'">
            <template v-slot:header>
              <!-- در حالت تک فرم -->
              <div class="" v-if="Rows">
                <table class="table table-bordered table-hover mt-3">
                  <thead>
                    <tr>
                      <th scope="col" colspan="8">
                        <h5>
                          درخواست های {{ Rows[0].formName ? Rows[0].formName : 'همه فرم ها' }} <span class="badge badge-secondary">{{ Rows.length }}</span>
                        </h5>
                      </th>
                    </tr>
                    <tr>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId != 4 && Rows[0].tblFormAutomationId != 5 && Rows[0].tblFormAutomationId != 6">حالت درخواست</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId == 1">نوع درخواست</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId == 1">از تاریخ</th>
                      <th scope="col" v-else>در تاریخ</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId == 1">تا تاریخ</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId != 4 && Rows[0].tblFormAutomationId != 5 && Rows[0].tblFormAutomationId != 6">از ساعت</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId != 4 && Rows[0].tblFormAutomationId != 5 && Rows[0].tblFormAutomationId != 6">تا ساعت</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId == 4">کالا | خدمات</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId == 4">مقدار</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId == 4">شرح خرید</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId == 5">موضوع</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId == 5 || Rows[0].tblFormAutomationId == 6">مبلغ (ریال)</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId == 5 || Rows[0].tblFormAutomationId == 6">توضیحات</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId == 1 || Rows[0].tblFormAutomationId == 2 || Rows[0].tblFormAutomationId == 3">مجموع زمان</th>
                      <th scope="col" v-if="Rows[0].tblFormAutomationId == 2 || Rows[0].tblFormAutomationId == 3">توضیحات</th>
                      <th scope="col" style="width: 36% !important">وضعیت</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, key) in Rows" :key="key" class="text-center">
                      <!-- روزانه یا ساعتی -->
                      <th v-if="row.tblFormAutomationId != 4 && row.tblFormAutomationId != 5 && row.tblFormAutomationId != 6">
                        <span v-if="row.tblCombogrp102NoeDarkhast == 1085236">ساعتی </span>
                        <span v-if="row.tblCombogrp102NoeDarkhast == 1085235">روزانه </span>
                        <span v-if="row.tblComboGrp102RoozaneSaati == 1085236">ساعتی </span>
                        <span v-if="row.tblComboGrp102RoozaneSaati == 1085235">روزانه </span>
                      </th>
                      <!-- استعلاجی و استحقاقی و بدوون حقوق-->
                      <td v-if="row.tblFormAutomationId == 1">
                        <span v-if="row.tblcombogrp103NoeMorakhasi == 1085237">استحقاقی </span>
                        <span v-if="row.tblcombogrp103NoeMorakhasi == 1085238">استعلاجی </span>
                        <span v-if="row.tblcombogrp103NoeMorakhasi == 1085239">بدون حقوق </span>
                      </td>
                      <!-- از تاریخ -->
                      <td>
                        <div v-if="row.tarixAz || row.date">
                          <span v-if="row.tarixAz"> {{ row.tarixAz }}</span>
                          <span v-if="row.date"> {{ row.date }}</span>
                        </div>
                        <div v-if="!row.tarixAz && !row.date">
                          <span dir="ltr"> {{ row.dateTimeInsert.slice(0, 10) }}</span>
                        </div>
                      </td>
                      <!-- تا تاریخ -->
                      <td v-if="row.tblFormAutomationId == 1">
                        <div>
                          <span v-if="row.tarixTa"> {{ row.tarixTa }}</span>
                          <span v-if="row.date"> {{ row.date }}</span>
                        </div>
                      </td>
                      <!-- از ساعت -->
                      <td v-if="row.tblFormAutomationId != 5 && row.tblFormAutomationId != 4 && row.tblFormAutomationId != 6">
                        <!-- ماموریت -->
                        <div v-if="row.tblFormAutomationId != 1 && row.tblComboGrp102RoozaneSaati && row.tblComboGrp102RoozaneSaati != 1085235">
                          <span> {{ row.startTime }} </span>
                        </div>
                        <!-- مرخصی -->
                        <div v-if="row.tblFormAutomationId == 1 && row.startTime != 'null'">
                          <span> {{ row.startTime }} </span>
                        </div>
                      </td>
                      <!-- تا ساعت -->
                      <td v-if="row.tblFormAutomationId != 5 && row.tblFormAutomationId != 4 && row.tblFormAutomationId != 6">
                        <!-- ماموریت -->
                        <div v-if="row.tblFormAutomationId != 1 && row.tblComboGrp102RoozaneSaati && row.tblComboGrp102RoozaneSaati != 1085235">
                          <span> {{ row.endTime }} </span>
                        </div>
                        <!-- مرخصی -->
                        <div v-if="row.tblFormAutomationId == 1 && row.endTime != 'null'">
                          <span> {{ row.endTime }} </span>
                        </div>
                      </td>
                      <!-- کالا و خدمات 4 -->
                      <td v-if="row.tblFormAutomationId == 4">
                        {{ row.commodity }}
                      </td>
                      <!-- مقدار 4 -->
                      <td v-if="row.tblFormAutomationId == 4">
                        {{ row.count }}
                      </td>
                      <!-- شرح خرید 4 -->
                      <td v-if="row.tblFormAutomationId == 4">
                        {{ row.for }}
                      </td>
                      <!-- موضوع 5 -->
                      <td v-if="row.tblFormAutomationId == 5">
                        {{ row.costSubject }}
                      </td>
                      <!-- مبلغ 5-6 -->
                      <td v-if="row.tblFormAutomationId == 5 || row.tblFormAutomationId == 6">
                        {{ $Comma3ragham(row.amount) }}
                      </td>
                      <!-- توضیحات 5 -->
                      <td v-if="row.tblFormAutomationId == 5">
                        {{ row.for }}
                      </td>
                      <!-- توضیحات 6 -->
                      <td v-if="row.tblFormAutomationId == 6">
                        {{ row.description }}
                      </td>
                      <!-- مقدار و تعداد روز و ساعت برای ماموریت و اضافه کاری -->
                      <td v-if="row.tblFormAutomationId == 2 || row.tblFormAutomationId == 3">
                        {{ row.tblComboGrp102RoozaneSaati != 1085235 ? $SubtractTime(row.startTime, row.endTime) + ' ساعت ' : row.dayCount + ' روز ' }}
                      </td>
                      <td v-if="row.tblFormAutomationId == 1">
                        {{ row.countDate == null ? $SubtractTime(row.startTime, row.endTime) + ' ساعت ' : row.countDate + ' روز ' }}
                      </td>
                      <!-- توضیحات اضافه کاری و ماموریت -->
                      <td v-if="row.tblFormAutomationId == 2 || row.tblFormAutomationId == 3">{{ row.des }}</td>
                      <td><cartabl-table-detail :DetailList="row.detail"></cartabl-table-detail></td>
                      <!-- <td><request-info  :RequestRow="row" :ApiAction="''" @Success="RefreshGrid" @DataEdit="DataEdit" :IsDelete="false" :IsEdit="false" :showInfo="true" :FormAutomation="1" :IsSarparast="false" :GetGrpUserInserted="row.tblUserId" ></request-info></td> -->
                    </tr>
                    <tr class="bg-result" v-if="Rows[0].tblFormAutomationId != 4">
                      <td colspan="8">
                        <span v-if="Rows[0].tblFormAutomationId != 5 && Rows[0].tblFormAutomationId != 6">مجموع ساعات درخواست های {{ Rows[0].formName }} در بازه زمانی فیلتر شده :</span>
                        <span v-else>مجموع مبالغ {{ Rows[0].formName }} در بازه زمانی فیلتر شده :</span>
                        <span class="text-danger d-inline mx-2">{{ GetFullTimeRequest(Rows) }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- در حالت همه -->
            </template>
          </Card>
        </div>
      </div>
    </div>
    <Loading v-if="loadingRender"></Loading>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import Treeselect from '@riophae/vue-treeselect'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import CartablTableDetail from '@/pages/Dashboard/components/BigStat/CartablTableDetail.vue'
import RequestInfo from '@/components/AutomAtion/RequestInfo.vue'
import Loading from '@/components/Loader/Loading.vue'

export default {
  components: { Card, Treeselect, datePicker: VuePersianDatetimePicker, CartablTableDetail, RequestInfo, Loading },
  data() {
    return {
      loadingRender: false,
      options: [],
      multiple: true,
      clearable: false,
      searchable: true,
      disabled: false,
      openOnClick: true,
      openOnFocus: false,
      clearOnSelect: true,
      closeOnSelect: false,
      alwaysOpen: false,
      appendToBody: false,
      value: [],
      normalizer(node) {
        return {
          id: node.Id,
          label: node.NamFam,
        }
      },
      FormList: [],
      filter: { ListUsersId: this.value, IsArchive: 1, FormAutomationId: -1, TarixAz: '', TarixTa: '' },
      Result: [],
      ResultReport: [],
      ResultReportForm: [],
      IsShowDetails: false,
      Rows: [],
    }
  },
  methods: {
    ItemSelected(node) {
      this.value.push(node)
    },
    ItemDeselect(node) {
      for (let index = 0; index < this.value.length; index++) {
        if (this.value[index].Id == node.Id) {
          this.value.splice(index, 1)
        }
      }
    },
    GetUserList() {
      var DataAxios_Get = {
        ArryfildValue: {},
        Method: 'GET',
        Action: 'TarifKarbaran',
        Token: this.$session.get('Token'),
      }
      this.$GetData_Body(DataAxios_Get).then((data) => {
        this.options = data
      })
    },
    GetUserListActive() {
      var DataAxios_Get = {
        ArryfildValue: {},
        Method: 'GET',
        Action: 'TarifKarbaran/GetUsersAvtive',
        Token: this.$session.get('Token'),
      }
      this.$GetData_Body(DataAxios_Get).then((data) => {
        this.value = data
      })
    },
    GetFormList() {
      var AxiosGet = { ArryfildValue: {}, Method: 'Get', Action: 'Cartabl/formList', Token: this.$session.get('Token') }
      this.$GetData_Body(AxiosGet).then((res) => {
        this.FormList = res
      })
    },
    SetDataDefault() {
      let SDate = this.$GetFirstAndLastDayOfMonth().SDate
      let EDate = this.$GetFirstAndLastDayOfMonth().EDate
      const moment = require('moment-jalaali')
      const dateAz = moment(SDate, 'jYYYY-jMM-jDD')
      const dateTa = moment(EDate, 'jYYYY-jMM-jDD')
      dateAz.subtract(1, 'jMonth')
      dateTa.subtract(1, 'jMonth')
      SDate = dateAz.format('jYYYY/jMM/jDD')
      EDate = dateTa.format('jYYYY/jMM/jDD')
      this.filter.TarixAz = SDate
      this.filter.TarixTa = EDate
    },
    SearchReport() {
      this.loadingRender = true
      this.IsShowDetails = false
      this.ResultReport = []
      this.filter.ListUsersId = JSON.stringify(this.value).slice(1, JSON.stringify(this.value).length - 1)
      this.$PostData_new('Post', 'ReportCartabl/ReportUsers', this.filter).then((data) => {
        let stamp = data.filter((x) => x.length > 0)
        let sumstamps = []
        stamp.forEach((element) => {
          element.forEach((x) => sumstamps.push(x))
        })
        this.Result = sumstamps
        let listUsers = []
        sumstamps.forEach((x) => {
          x.selProcessWorkFlowForUser['detail'] = x.detail
          x.selProcessWorkFlowForUser['FKTable'] = x.tblFk
          listUsers.push(x.selProcessWorkFlowForUser)
        })
        let arr = Object.groupBy(listUsers, ({ tblUserId }) => tblUserId)
        for (var key in arr) {
          this.ResultReport.push(arr[key])
        }
        this.loadingRender = false
      })
    },
    Sort(elm, ky) {
      // let listarr=[]
      // console.log("😎 ~ Sort ~ elm:", elm)
      // console.log("😎 ~ Sort ~ elm:", this.ResultReport[ky])
      // this.ResultReport[ky].forEach(el=>{
      //   if (el.tblFormAutomationId==1) {
      //     if (el.FKTable.tarixAz>=this.filter.TarixAz && el.FKTable.tarixAz<=this.filter.TarixTa) {
      //       // listarr.push(el)
      //       alert()
      //     }
      //   }
      // })
      this.IsShowDetails = false
      this.ResultReportForm = []
      let array = Object.groupBy(elm, ({ tblFormAutomationId }) => tblFormAutomationId)
      for (var key in array) {
        this.ResultReportForm.push(array[key])
      }
    },
    ShowDetail(elm) {
      this.loadingRender = true
      let list = []
      elm.forEach((el) => {
        this.Result.forEach((val) => {
          if (val.tblFk.id == el.fkId) {
            this.GetGrpOntblUser(val.tblFk.tblUserId, val.tblFk.id).then((data) => {
              val.tblFk['detail'] = data
              val.tblFk['formName'] = el.formName
                val.tblFk['tblFormAutomationId'] = el.tblFormAutomationId
                list.push(val.tblFk)
            })
          }
        })
      })
      this.Rows = list
      // this.sortByTarixAz(this.Rows).then(dt=>{
      //   console.warn(dt);
      //   this.Rows =dt
      // })
      this.IsShowDetails = true
      // this.Rows = elm
    },
    sortByTarixAz(objects) {
      return new Promise((success, fail) =>{
        const moment = require('moment-jalaali');
        objects.sort(function (a, b) {
        // تبدیل تاریخ‌ها به آبجکت‌های Date
        var dateA =a.tarixAz
        var dateB = b.tarixAz
        // مقایسه تاریخ‌ها و بازگشت مقدار مقایسه‌شده
        return dateA - dateB
      })
      success(objects)
      })
    },
    GetGrpOntblUser(userid, fkid) {
      return new Promise((success, fail) => {
        var axios = { Method: 'Get', Action: 'ReportCartabl/GetGrp/?UserId=' + userid, Arryfildvalue: null }
        this.$PostData(axios).then((result) => {
          if (result.grpId && result.grpId > 0) {
            let grp = result.grpId
            let fk = fkid
            var axios = { Method: 'Get', Action: 'SelProcessWorkflowList/?Id=' + fk + '&tblGrpId=' + grp, Arryfildvalue: null }
            this.$PostData(axios).then((result) => {
              this.loadingRender = false
              success(result.data)
            })
          }
        })
      })
    },
    GotoNextMonth() {
      const moment = require('moment-jalaali')
      let SDate = this.filter.TarixAz
      let EDate = this.filter.TarixTa
      const dateAz = moment(SDate, 'jYYYY-jMM-jDD')
      const dateTa = moment(EDate, 'jYYYY-jMM-jDD')
      dateAz.add(1, 'jMonth')
      dateTa.add(1, 'jMonth')
      SDate = dateAz.format('jYYYY/jMM/jDD')
      EDate = dateTa.format('jYYYY/jMM/jDD')
      this.filter.TarixAz = SDate
      this.filter.TarixTa = moment(this.filter.TarixAz, 'jYYYY-jMM-jDD').endOf('jMonth').format('jYYYY/jMM/jDD')
    },
    GotoPreventMonth() {
      const moment = require('moment-jalaali')
      let SDate = this.filter.TarixAz
      let EDate = this.filter.TarixTa
      const dateAz = moment(SDate, 'jYYYY-jMM-jDD')
      const dateTa = moment(EDate, 'jYYYY-jMM-jDD')
      dateAz.subtract(1, 'jMonth')
      dateTa.subtract(1, 'jMonth')
      SDate = dateAz.format('jYYYY/jMM/jDD')
      EDate = dateTa.format('jYYYY/jMM/jDD')
      this.filter.TarixAz = SDate
      this.filter.TarixTa = moment(this.filter.TarixAz, 'jYYYY-jMM-jDD').endOf('jMonth').format('jYYYY/jMM/jDD')
    },
    GetFullTimeRequest(lsitReq) {
      let Day = 0
      let Minutes = '00:00'
      if (lsitReq[0].tblFormAutomationId == 1) {
        Day = 0
        Minutes = '00:00'
        lsitReq.map((el) => {
          if (el.countDate != null) {
            Day += el.countDate
          } else {
            let formattedTime = this.$ConvertTimeToStandardTime(this.$SubtractTime(el.startTime, el.endTime))
            Minutes = this.$addTimes(Minutes, formattedTime.substring(0, 5))
          }
        })
        return Day + ' روز و ' + Minutes + ' ساعت '
      } else if (lsitReq[0].tblFormAutomationId == 2) {
        Day = 0
        Minutes = '00:00'
        lsitReq.map((el) => {
          if (el.dayCount != null) {
            Day += el.dayCount
          } else {
            let formattedTime = this.$ConvertTimeToStandardTime(this.$SubtractTime(el.startTime, el.endTime))
            Minutes = this.$addTimes(Minutes, formattedTime.substring(0, 5))
          }
        })
        return Day + ' روز و ' + Minutes + ' ساعت '
      } else if (lsitReq[0].tblFormAutomationId == 3) {
        Day = 0
        Minutes = '00:00'
        lsitReq.map((el) => {
          if (el.dayCount != null) {
            Day += el.dayCount
          } else {
            let formattedTime = this.$ConvertTimeToStandardTime(this.$SubtractTime(el.startTime, el.endTime))
            Minutes = this.$addTimes(Minutes, formattedTime.substring(0, 5))
          }
        })
        return Day + ' روز و ' + Minutes + ' ساعت '
      } else if (lsitReq[0].tblFormAutomationId == 5) {
        Day = 0
        Minutes = '00:00'
        lsitReq.map((el) => {
          Day += el.amount
        })
        return this.$Comma3ragham(Day) + ' ریال '
      } else if (lsitReq[0].tblFormAutomationId == 6) {
        Day = 0
        Minutes = '00:00'
        lsitReq.map((el) => {
          Day += el.amount
        })
        return this.$Comma3ragham(Day) + ' ریال '
      }
      console.log('😎 ~ GetFullTimeLeaveReq ~ lsitReq:', lsitReq)
    },
    DataEdit() {},
    RefreshGrid() {},
  },
  created() {
    this.SetDataDefault()
    this.GetUserList()
    this.GetUserListActive()
    this.GetFormList()
  },
}
</script>
<style scoped>
.FormStyle {
  height: 30px !important;
  border-right: 3px solid var(--logo-color);
  padding: 1%;
  vertical-align: middle !important;
  color: var(--sidebar-color-item);
}
tr {
  color: var(--sidebar-color-item) !important;
}
table {
  background: var(--sidebar-bg-color) !important;
  color: var(--sidebar-color-item);
}
td {
  border-color: var(--table-border-color) !important;
}
th {
  font-weight: normal;
  text-align: center;
  font-size: 12px;
  color: var(--sidebar-color-item) !important;
  border-color: var(--table-border-color) !important;
}
thead {
  border-color: var(--table-border-color) !important;
}
tr:hover {
  color: var(--sidebar-color-item) !important;
  background: var(--sidebar-progress-bg-color) !important;
}
tbody {
  border: rgb(255, 255, 255) !important;
}

.bg-result {
  background: var(--sidebar-progress-bg-color) !important;
}
</style>
